(() => {
  const currentScript = document.currentScript;
  const styleHref = currentScript?.dataset.styleSrc;
  const marker = 'data-iniu-cimage-engraving-style';

  if (!styleHref) return;

  const applyStyle = (host) => {
    if (!host?.shadowRoot || host.shadowRoot.querySelector(`link[${marker}]`)) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = styleHref;
    link.setAttribute(marker, '');
    host.shadowRoot.appendChild(link);
  };

  const scan = () => {
    document.querySelectorAll('ci-preview').forEach(applyStyle);
  };

  const startScan = () => {
    scan();

    let attempts = 0;
    const timer = window.setInterval(() => {
      scan();
      attempts += 1;

      if (attempts > 40) window.clearInterval(timer);
    }, 250);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startScan, { once: true });
  } else {
    startScan();
  }

  document.addEventListener('shopify:section:load', startScan);

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
